export class NoActiveGroupError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'NoActiveGroupError';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NoActiveGroupError);
    }
  }
}
